import Vue from 'vue';
import Vuex from 'vuex';
import shopAuth from './shopAuth';
import auth from './auth';
import products from './products';
import inventory from './inventory';
import inventaire from './inventaire';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    shopAuth,
    auth,
    products,
    inventory,
    inventaire,
  },
});
